import team from "./team.vue";

export default [
  {
    name: "admin-team",
    path: "/admin/team",
    component: team,
  },
];
